export default "__VITE_ASSET__CFYq04y1__"